import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import 'rxjs/Rx';

import {StoreService} from './shared';
import {LocalService} from './shared';
/*
import {AlertService} from './shared/alert/alert.service';
import {ThreatService} from './shared/threat/threat.service';
*/
import {AlertService, ThreatService, CognitoAuthService} from './shared';

import {MainComponent} from './containers/main/main.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [StoreService, AlertService, ThreatService]
})
export class AppComponent implements OnInit {

    isLoading: boolean;

    constructor(private router: Router,
                private store: StoreService,
                private local: LocalService,
                private cognitoAuthService: CognitoAuthService,
                private alertService: AlertService,
                private threatService: ThreatService) {

        const self = this;
        self.isLoading = false;
        this.store.onChange('isLoading', function (isLoading) {
            self.isLoading = isLoading;
        });

    }

    ngOnInit() {
        this.local.setTheme();
        const currentUser = this.cognitoAuthService.getCurrentUser();
        if (!currentUser || !currentUser.Session) {

            console.log('User not found, so redirecting to sign-in page...');

            this.router.navigate(['sign-in']);
        }
    }

    showLoader(isLoading: boolean) {
        // const isLoading = this.store.get('isLoading');
        // currentState.isLoading = isLoading;
        this.store.update('isLoading', isLoading);
    }

}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts